import { render } from "./IDOverview.vue?vue&type=template&id=a47f17ba&ts=true"
import script from "./IDOverview.ts?vue&type=script&lang=ts&external"
export * from "./IDOverview.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__